module.exports = __webpack_public_path__ + "static/media/logo.e47c0531.png";